import { render } from "./LicenseDetails.vue?vue&type=template&id=73d3477b"
import script from "./LicenseDetails.vue?vue&type=script&lang=js"
export * from "./LicenseDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__